import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  Suspense,
  useLayoutEffect,
} from "react";
import ReactDOM from "react-dom";
import {
  HashRouter as Router,
  Switch,
  Route,
  useLocation,
  useHistory,
  Redirect,
} from "react-router-dom";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import { store } from "@redux/store";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { copyright, references } from "@static/footer-information";
import {
  PRODUCT_CODE_API,
  getBanks,
  getCampaignData,
  getConfig,
  getCsrfToken,
  getEverGreenCampaignCode,
  postCampaign,
  postGetPersonalDetails,
  postValidateAdviser,
  protocol,
  protocolNew,
  protocolUpload,  
  GIOCampaignEligibilityCheck,
  QRClientDetails,
} from "@api/index";
import {
  DEFAULT_CONFIG,
  MLTC_CAMPAIGN_CODES_LIST,
  PLANS_NAME,
  SHIELD_STARTER_CAMPAIGN_CODES_LIST,
} from "@static/config";
import {
  setShowAddInfo,
  setEnableSIO,
  setCampaignDetail,
  setLoadingState,
  setIsGlobalError,
  setErrorContent,
  setIsTokenRecieved,
  setInvalidArcCodeFromUrl,
  setCampaignEligibilityFlags
} from "@redux/slices/loadingSlice";
import { updateBrochureUrl } from "@redux/slices/staticSlice";
import { Header as RevampHeader } from "@components/_Revamp/Header";
import Header from "@components/Header";
import Footer from "@components/Footer";
import Spinner from "@components/Spinner";
import SpinnerRevamp from "@components/_Revamp/Spinner";
import NotFoundPage from "@pages/NotFound";
import { get, identity, isEmpty, pickBy } from "lodash";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "./theme";
import { ThemeProvider as ThemeProviderR3 } from "./theme-revamp";
import "./index.css";
import {
  sioRoutes,
  dpiRoutes,
  mltcRoutes,
  mltcR3Routes,
  ShieldStarter,
  EverGreen,
  CancerCover,
} from "./routes";
import {
  Helpers,
  LoadingScreen,
  getFastPaymentRedirectedUrlAfterRedirect,
  setCurentPolicyFlowInStore,
} from "@utils/helpers";
import loadGAScript from "@utils/gaScript";
import { updateBanks } from "@redux/slices/staticSlice";
import { GAAviva } from "@utils/gaAviva";
import Modal from "@components/Modal";
import Text from "@components/Text";
import Heading from "@components/Heading";
import { updateUrlParam } from "@redux/slices/MLTC_R3/urlAnalyticSlice";
import ModalView from "./Modal";
import { ROUTE_PATH } from "@static/route-paths";
import RedirectToGetQuote from "@pages/ShieldStarter/Components/RedirectToGetQuote";
import ShieldStarterIdleTimeout from "@pages/ShieldStarter/Components/Modals/ShieldStarterIdleTimeout";
import ShieldStarterSessionTimeout from "@pages/ShieldStarter/Components/Modals/ShieldStarterSessionTimeout";
import { updateAgentCodeFromUrl } from "@redux/slices/SHIELD_STARTER/step4Slice";
import useShieldStarterReduxReset from "@pages/ShieldStarter/Helpers/useReduxReset";
import useCCPReduxReset from "@pages/CCP/Helpers/useReduxReset";
import Toast from "@pages/ShieldStarter/Components/Toast";
import {
  addNotification,
  removeNotification,
} from "@redux/slices/SHIELD_STARTER/step1Slice";
import { INCORRECT_ADVISER_NOTIFICATION } from "@static/NotificationTypes";
import { AgentPersonalDetailRequest } from "@models/AgentPersonalDetailRequest.model";
import IdleTimeout from "@pages/EverGreen/Components/IdleTimeout";
import SessionTimeout from "@pages/EverGreen/Components/SessionTimeout";
import { updateValidPromoCodeValidity, updatePromoCode, updateQRClntNum, updateQRClientDetails, updateAgentDetailResponseRaw, updateShowArcPage, setEBCampaignLookupComplete, setCcCampaignLookupComplete } from "@redux/slices/MLTC_R3/step5Slice";

declare var window: any;

let persistor = persistStore(store);

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
const Loading = () => {
  const isLoading = useAvivaSelector((state) => state.loading.isShowing);
  const location: any = useLocation();
  const IS_MLTC = location.pathname.includes("/mltc/");
  const isRevamped = useAvivaSelector(
    (state) => state.loading.CurrentPolicyFlow.isRevampedLayout
  );
  return (
    <>
      {(IS_MLTC || isRevamped) && <SpinnerRevamp show={isLoading} />}
      {!(IS_MLTC || isRevamped) && <Spinner show={isLoading} />}
    </>
  );
};
const GenericPopup = () => {
  const dispatch = useAvivaDispatch();
  const isGlobalError = useAvivaSelector(
    (state) => state.loading.isGlobalError
  );
  let errorContent = useAvivaSelector((state) => state.loading.errorContent);

  console.log("errorContent", errorContent);

  const onClose = useCallback(() => {
    dispatch(setIsGlobalError(false));
  }, []);
  return (
    <Modal show={isGlobalError} onClose={onClose}>
      <Heading
        variant="smallTitle"
        fontWeight={600}
        margin="0 0 20px"
        marginTablet="0 0 30px"
      >
        {errorContent ? errorContent[0] : ""}
      </Heading>
      <Text>{errorContent ? errorContent[1] : ""}</Text>
    </Modal>
  );
};

const DynamicHeader = () => {
  const history = useHistory();
  const stateCampaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const [isCIMB, setIsCIMB] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const location: any = useLocation();
  const dispatch = useAvivaDispatch();
  const isTokenSet = useAvivaSelector((state) => state.loading.isTokenRecieved);
  const notifications = useAvivaSelector(
    (state) => state.shieldStarterStep1.notifications
  );
  const retrievedMyInfo = useAvivaSelector(
    (state) => state.mltcR3Step4?.retrievedMyInfo
  );
  const isShieldStarterAgentCode = useAvivaSelector(
    (state) => state.shieldStarterStep4.agentCodeFromUrl
  );

  const IS_MLTC = location.pathname.includes("/mltc/");
  const paramsFromStore = useAvivaSelector((state) => state.urlAnalytic.param);
  const isRevampedTheme = useAvivaSelector(
    (state) => state.loading.CurrentPolicyFlow.isRevampedLayout
  );
  const IS_SHIELD_STARTER = location.pathname.includes("/shieldstarter/");
  const IS_SECURE_SAVER = location.pathname.includes("/evergreen/");
  const IS_SHIELD_STARTER_CONFIRMATION = location.pathname.includes(
    ROUTE_PATH.SHIELD_STARTER_COFIRMATION
  );
  const IS_SHIELD_STARTER_QUOTE = location.pathname.includes(
    ROUTE_PATH.SHIELD_STARTER_GET_QUOTE
  );
  const IS_SHIELD_STARTER_SINGPASS = location.pathname.includes(
    ROUTE_PATH.SHIELD_STARTER_SINGPASS_PERSMISSION
  );
  const IS_SHIELD_STARTER_REVIEW = location.pathname.includes(
    ROUTE_PATH.SHIELD_STARTER_REVIEW
  );
  const IS_SHIELD_STARTER_CONTACT_US = location.pathname.includes(
    ROUTE_PATH.SHIELD_STARTER_CONTACT_US
  );
  const IS_SHIELD_STARTER_ERROR = location.pathname.includes(
    ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR
  );
  const IS_SHIELD_STARTER_CON_ERROR = location.pathname.includes(
    ROUTE_PATH.SHIELD_STARTER_CONNECTION_ERROR
  );
  const IS_SHIELD_STARTER_MY_INFO = location.pathname.includes(
    ROUTE_PATH.SHIELD_STARTER_MY_INFO
  );
  const IS_MLTC_MY_INFO = location.pathname.includes(ROUTE_PATH.MLTC_MY_INFO);
  const IS_MLTC_LETS_GET_STARTED = location.pathname.includes(
    ROUTE_PATH.MLTC_LETS_GET_STARTED
  );

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const alertUser = (event: any) => {
    if (
      !IS_SHIELD_STARTER ||
      IS_SHIELD_STARTER_CONFIRMATION ||
      IS_SHIELD_STARTER_QUOTE ||
      IS_SHIELD_STARTER_SINGPASS ||
      IS_SHIELD_STARTER_REVIEW ||
      IS_SHIELD_STARTER_CONTACT_US ||
      IS_SHIELD_STARTER_ERROR ||
      IS_SHIELD_STARTER_CON_ERROR
    )
      return;
    event.preventDefault();
    event.returnValue = ""; // Required for Chrome
    return ""; // Required for Firefox
  };

  useEffect(() => {
    if (IS_SHIELD_STARTER) {
      window.addEventListener("beforeunload", alertUser);
    }

    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, [
    IS_SHIELD_STARTER,
    IS_SHIELD_STARTER_CONFIRMATION,
    IS_SHIELD_STARTER_QUOTE,
    IS_SHIELD_STARTER_SINGPASS,
    IS_SHIELD_STARTER_REVIEW,
    IS_SHIELD_STARTER_CONTACT_US,
    IS_SHIELD_STARTER_ERROR,
    IS_SHIELD_STARTER_CON_ERROR,
  ]);

  useEffect(() => {
    // Update network status
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    if (IS_SHIELD_STARTER) {
      window.addEventListener("online", handleStatusChange);
      window.addEventListener("offline", handleStatusChange);
    }

    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, []);

  useEffect(() => {
    if (!isOnline) history.push(ROUTE_PATH.SHIELD_STARTER_CONNECTION_ERROR);
  }, [isOnline]);

  const navigateToErrorPage = () => {
    if (location.pathname.includes("/shieldstarter/")) {
      history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
    } else if (location.pathname.includes("/mltc/")) {
      history.push("/mltc/something-wrong");
    } else if (location.pathname.includes("/sio/")) {
      history.push("/sio/contact");
    } else if (location.pathname.includes("/dpi/")) {
      history.push("/dpi/contact");
    }
  };

  const checkCampaignCode = useCallback(
    async (reattempt: boolean = false) => {
      if (
        !protocol.defaults.headers["X-XSRF-TOKEN"] ||
        !protocolNew.defaults.headers["X-XSRF-TOKEN"] ||
        !protocolUpload.defaults.headers["X-XSRF-TOKEN"]
      ) {
        if (!reattempt) {
          setTimeout(async () => {
            if (
              !protocol.defaults.headers["X-XSRF-TOKEN"] ||
              !protocolNew.defaults.headers["X-XSRF-TOKEN"] ||
              !protocolUpload.defaults.headers["X-XSRF-TOKEN"]
            ) {
              try {
                const token = await getCsrfToken();
                protocolUpload.defaults.headers["X-XSRF-TOKEN"] = token.data;
                protocolNew.defaults.headers["X-XSRF-TOKEN"] = token.data;
                protocol.defaults.headers["X-XSRF-TOKEN"] = token.data;
                dispatch(setIsTokenRecieved(true))
              } catch {
                navigateToErrorPage();
              }
            }
            checkCampaignCode(true);
          }, 200);
        }
        if (!reattempt) return;
      }

      try {
        // Retrieve campaign code details
        const params = new URLSearchParams(window.location.href.split("?")[1]);
        const campaignCode = params.get("cc");
        console.log("QnB ➤ DynamicHeader() ➤ check url campaignCode", {
          campaignCode,
          location,
        });

        console.log(
          "location.pathname.includes('mltc')",
          location.pathname.includes("mltc")
        );
        console.log("campaignCode", campaignCode);
        // MLTC flow campaign code checks
        if (!!campaignCode && location.pathname.includes("mltc")) {
          dispatch(setLoadingState(true));
          // When campaign code param found
          const responseCampaign = await postCampaign({
            campaign: campaignCode,
          });
          const campaignDetail = get(responseCampaign, "data", {});
          const validCode = !!campaignDetail.description;
          if (validCode && campaignDetail?.product === "CARESHIELD") {
            console.log("CIMB =", campaignDetail?.code === "LCB1");
            setIsCIMB(campaignDetail?.code === "LCB1");
            dispatch(setCampaignDetail({ ...campaignDetail, campaignCode }));
          }
        } else if (location.pathname.includes("mltc")) {
          // When no campaign code on url
          const fromPayment =
            window.location.href.split("?")[0].indexOf("payment") >= 0;
          // When redirect from payment
          const status = params.get("status");
          console.log("campaign param check", { fromPayment, status });
          if (
            fromPayment &&
            (status === "unsuccessful" || status === "processing")
          ) {
            setIsCIMB(stateCampaignDetail?.code === "LCB1");
          } else {
            if (stateCampaignDetail) {
              console.log("setCampaignDetail set null");
              //dispatch(setCampaignDetail(null));
              // setIsCIMB(stateCampaignDetail?.code === 'LCB1');
            }
          }
        } else if (
          !!campaignCode &&
          location.pathname.includes("shieldstarter")
        ) {
          dispatch(setLoadingState(true));
          const responseCampaign = await getCampaignData({
            campaign: campaignCode,
          });
          const campaignDetail = get(responseCampaign, "data", {});

          if (
            campaignDetail.description &&
            campaignDetail?.product === "SHIELDSTARTER"
          ) {
            dispatch(setCampaignDetail({ ...campaignDetail, campaignCode }));
          }
        } else if (!!campaignCode && location.pathname.includes("evergreen")) {
          dispatch(setLoadingState(true));
          const responseCampaign = await getEverGreenCampaignCode({
            campaign: campaignCode,
          });
          const campaignDetail = get(responseCampaign, "data", {});

          if (
            campaignDetail.description &&
            campaignDetail?.product === "DIGITALSAVER"
          ) {
            dispatch(setCampaignDetail({ ...campaignDetail, campaignCode }));
          }
        }
      } catch (error) {
        console.error("QnB ➤ checkCampaignCode() ➤ error", { error });
        window["AVIVA_VARIABLE_CONFIG"] = DEFAULT_CONFIG;
        if (IS_SHIELD_STARTER)
          history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
        if (IS_MLTC) history.push("/mltc/something-wrong");
      } finally {
        dispatch(setLoadingState(false));
        // QB-AA-Tracking fix: tells BasicDetails.tsx the `?cc=` campaign lookup (direct
        // EBLTC link, no QR) has settled - whether it found a campaign or not - so it can
        // tell "still loading" apart from "resolved to no campaign" before firing step 1.
        dispatch(setCcCampaignLookupComplete(true));
      }
    },
    [dispatch, setIsCIMB, location]
  );

  // useEffect(()=>{
  //   if (!Helpers.setUrlAnalyticParams().arc &&
  //     notifications?.some(notification => notification?.title === INCORRECT_ADVISER_NOTIFICATION.title) &&
  //     (IS_SHIELD_STARTER_MY_INFO || (IS_MLTC_MY_INFO && retrievedMyInfo)))
  //     dispatch(removeNotification(INCORRECT_ADVISER_NOTIFICATION));
  // }, [retrievedMyInfo]);
  const qrClientDetails = useAvivaSelector(
    (state) => state.mltcR3Step5.qrClientDetails,
  );

  const encryptedClntNum = useAvivaSelector(
    (state) => state.mltcR3Step5.clntNum,
  );

  useEffect(() => {
    if (!encryptedClntNum) return;
    if (!(IS_MLTC || IS_MLTC_LETS_GET_STARTED)) return;
    if (qrClientDetails) return;
    if (!isTokenSet) return;
    const fetchQRClientDetails = async () => {
      try {
        const QRPayload = { cipherString: encryptedClntNum };
        const QRResponse = await QRClientDetails(QRPayload);
        const QRData = get(QRResponse, "data", null);

        dispatch(updateQRClientDetails(QRData));
      } catch (err) {
        console.error("QRClientDetails failed", err);
        dispatch(updateQRClientDetails({ status: "FAILURE", clientMasterData: null }));
      }
    };

    fetchQRClientDetails();
  }, [encryptedClntNum, qrClientDetails, isTokenSet, dispatch]);

  useEffect(() => {
    if (!qrClientDetails) return;

    const ebCampaignCode = qrClientDetails?.clientMasterData?.ebCampaignCode;
    if (qrClientDetails?.status !== "SUCCESS" || !ebCampaignCode || stateCampaignDetail) {
      dispatch(setEBCampaignLookupComplete(true));
      return;
    }

    const dob = qrClientDetails?.clientMasterData?.dob;
    const age = dob ? Helpers.getAge(new Date(dob)) : null;
    // EB promotion only applies to customers aged 31-40 (ANB); outside this range, fall back to plain QR LTC
    if (age === null || age < 31 || age > 40) {
      dispatch(setEBCampaignLookupComplete(true));
      return;
    }

    const fetchEBCampaignDetail = async () => {
      try {
        const responseCampaign = await postCampaign({ campaign: ebCampaignCode });
        const campaignDetail = get(responseCampaign, "data", {});
        const validCode = !!campaignDetail?.description;

        if (
          validCode &&
          campaignDetail?.product === "CARESHIELD" &&
          campaignDetail?.code === "EBLTC" &&
          campaignDetail?.status !== "EXPIRED"
        ) {
          dispatch(setCampaignDetail({ ...campaignDetail, campaignCode: ebCampaignCode }));
        }
      } catch (err) {
        console.error("QnB ➤ fetchEBCampaignDetail() ➤ error", err);
      } finally {
        dispatch(setEBCampaignLookupComplete(true));
      }
    };

    fetchEBCampaignDetail();
  }, [qrClientDetails, stateCampaignDetail, dispatch]);

  useEffect(() => {
    async function validateAgentCode(arc: string, pm: string, clntNum: string, reattempt: boolean = false) {
      try {
        let response = {};
        if (
          !protocol.defaults.headers["X-XSRF-TOKEN"] ||
          !protocolNew.defaults.headers["X-XSRF-TOKEN"] ||
          !protocolUpload.defaults.headers["X-XSRF-TOKEN"]
        ) {
          if (!reattempt) {
            setTimeout(async () => {
              if (
                !protocol.defaults.headers["X-XSRF-TOKEN"] ||
                !protocolNew.defaults.headers["X-XSRF-TOKEN"] ||
                !protocolUpload.defaults.headers["X-XSRF-TOKEN"]
              ) {
                try {
                  const token = await getCsrfToken();
                  protocolUpload.defaults.headers["X-XSRF-TOKEN"] = token.data;
                  protocolNew.defaults.headers["X-XSRF-TOKEN"] = token.data;
                  protocol.defaults.headers["X-XSRF-TOKEN"] = token.data;
                  dispatch(setIsTokenRecieved(true));
                } catch {
                  navigateToErrorPage();
                }
              }
              validateAgentCode(arc, pm, clntNum, true);
            }, 200);
          }
          if (!reattempt) return;
        }
        if (IS_SHIELD_STARTER) {
          response = await postValidateAdviser(
            arc,
            PRODUCT_CODE_API.SHIELD_STARTER
          );
        } else if (IS_MLTC) {
          response = await postGetPersonalDetails(
            new AgentPersonalDetailRequest({ agentCode: arc, promoCode: pm})
          );
        }
        const data: any = get(response, "data.data", null);
        const validPromoCodeData: any = get(response, "data", null);
        dispatch(updateValidPromoCodeValidity(validPromoCodeData?.validPromoCode));
        dispatch(updatePromoCode(pm));
        dispatch(updateQRClntNum(clntNum));
        dispatch(updateAgentDetailResponseRaw(data));
        dispatch(updateShowArcPage(true));
        if (!data || data?.agentTerminatedFlag === "Y") {
          dispatch(updateUrlParam({ ...paramsFromStore, arc: "", pm: "", qrCd: "" }));
          dispatch(setInvalidArcCodeFromUrl(true));
          if (
            !notifications?.some(
              (notification) =>
                notification?.title === INCORRECT_ADVISER_NOTIFICATION.title
            )
          )
            dispatch(addNotification(INCORRECT_ADVISER_NOTIFICATION));
          if (isShieldStarterAgentCode) dispatch(updateAgentCodeFromUrl(""));
        } else if (
          IS_SHIELD_STARTER &&
          data &&
          data.agentTerminatedFlag === "N"
        ) {
          dispatch(updateAgentCodeFromUrl(arc));
        }
      } catch {
        dispatch(updateUrlParam({ ...paramsFromStore, arc: "", pm: "", qrCd: ""}));
        dispatch(setInvalidArcCodeFromUrl(true));
        if (isShieldStarterAgentCode) dispatch(updateAgentCodeFromUrl(""));

        if (IS_SHIELD_STARTER)
          history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
        if (IS_MLTC) history.push("/mltc/something-wrong");
      }
    }

    if (!isLoaded) {
      let paramsFromUrl = Helpers.setUrlAnalyticParams();
      if (
        paramsFromUrl.arc &&
        (IS_SHIELD_STARTER_QUOTE || IS_MLTC_LETS_GET_STARTED)
      )
        validateAgentCode(paramsFromUrl.arc, (paramsFromUrl.pm)?.replace(/ /g, "+"), paramsFromUrl.qrCd);
      if (
        paramsFromUrl.arc &&
        !(IS_SHIELD_STARTER_QUOTE || IS_MLTC_LETS_GET_STARTED)
      )
        paramsFromUrl = { ...paramsFromUrl, arc: paramsFromStore.arc, pm: paramsFromStore.pm, qrCd: paramsFromStore.qrCd};
      dispatch(
        updateUrlParam({
          ...paramsFromStore,
          ...pickBy(paramsFromUrl, identity),
        })
      );
      checkCampaignCode();
      setIsLoaded(true);
    }
    if (location?.pathname?.includes("evergreen")) {
      const { productName } = store.getState().everGreenStep1.staticData;
      if (productName) {
        document.title = document.title.replace(
          "Singlife Digital Saver",
          productName
        );
      }
    }
    return () => {
      dispatch(removeNotification(INCORRECT_ADVISER_NOTIFICATION));
    };
  }, [isLoaded, checkCampaignCode]);

  return (
    <>
      {(IS_MLTC || IS_SHIELD_STARTER || IS_SECURE_SAVER || isRevampedTheme) && (
        <RevampHeader />
      )}
      {!IS_MLTC && <Header planName="MrSampleTermPlan" isCIMB={isCIMB} />}
    </>
  );
};

/**
 * Check and return footer component based on location path
 * @returns {JSX.Element}
 */
const DynamicFooter = () => {
  const location: any = useLocation();
  const IS_MLTC = location.pathname.includes("/mltc");
  const IS_SHIELD_STARTER = location.pathname.includes("/shieldstarter");
  const IS_EVER_GREEN = location.pathname.includes("/evergreen");
  const IS_CANCER_COVER = location.pathname.includes("/ccp");

  return (
    <>
      {!IS_MLTC && !IS_SHIELD_STARTER && !IS_EVER_GREEN && !IS_CANCER_COVER && (
        <Footer copyright={copyright} references={references} />
      )}
    </>
  );
};

export interface DynamicThemeProviderProps {
  children: React.ReactNode;
}
const DynamicThemeProvider = ({ children }: DynamicThemeProviderProps) => {
  const location: any = useLocation();
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const [isCsrfToken, setIsCsrfToken] = useState(false);
  const IS_MLTC = location.pathname.includes("/mltc/");
  const isRevampedTheme = useAvivaSelector(
    (state) => state.loading.CurrentPolicyFlow.isRevampedLayout
  );
  const shieldstarter = location.pathname.includes("/shieldstarter/");
  const evergreen = location.pathname.includes("/evergreen/");
  const cancercover = location.pathname.includes("/ccp/");

  if (shieldstarter || evergreen || cancercover) {
    document.body.classList.add("shieldstarter");
    document.documentElement.classList.add("shieldstarter");
  } else {
    document.body.classList.remove("shieldstarter");
    document.documentElement.classList.remove("shieldstarter");
  }
  useEffect(() => {
    async function SetCsrfToken() {
      dispatch(setLoadingState(true));
      try {
        if (sessionStorage.getItem("token")) {
          protocolNew.defaults.headers["X-XSRF-TOKEN"] =
            sessionStorage.getItem("token") || "";
          protocol.defaults.headers["X-XSRF-TOKEN"] =
            sessionStorage.getItem("token") || "";
          protocolUpload.defaults.headers["X-XSRF-TOKEN"] =
            sessionStorage.getItem("token") || "";
          dispatch(setIsTokenRecieved(true));
          setIsCsrfToken(true);
          dispatch(setLoadingState(false));
          return;
        }
        const token = await getCsrfToken();
        sessionStorage.setItem("token", token.data);
        protocolUpload.defaults.headers["X-XSRF-TOKEN"] = token.data;
        protocolNew.defaults.headers["X-XSRF-TOKEN"] = token.data;
        protocol.defaults.headers["X-XSRF-TOKEN"] = token.data;
        dispatch(setIsTokenRecieved(true));
        setIsCsrfToken(true);
      } catch {
        if (location.pathname.includes("/shieldstarter/")) {
          history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
        } else if (location.pathname.includes("/mltc/")) {
          history.push("/mltc/something-wrong");
        } else if (location.pathname.includes("/sio/")) {
          history.push("/sio/contact");
        } else if (location.pathname.includes("/dpi/")) {
          history.push("/dpi/contact");
        }
      }
      dispatch(setLoadingState(false));
    }
    if (process.env.REACT_APP_ENVIRONMENT === "DEV") {
      setIsCsrfToken(true);
      return;
    }
    if (
      !protocolNew.defaults.headers["X-XSRF-TOKEN"] ||
      !protocol.defaults.headers["X-XSRF-TOKEN"] ||
      !protocolUpload.defaults.headers["X-XSRF-TOKEN"]
    ) {
      SetCsrfToken();
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   if (process.env.REACT_APP_ENVIRONMENT === "DEV") {
  //     dispatch(setIsTokenRecieved(true));
  //   }
  // }, []);

  if (!isCsrfToken) {
    return <></>;
  }
  if (IS_MLTC || isRevampedTheme) {
    document.body.setAttribute("data-theme", "r3-theme");
    return (
      <>
        <ThemeProviderR3>{children}</ThemeProviderR3>
      </>
    );
  } else {
    document.body.setAttribute("data-theme", "");
    return (
      <>
        <ThemeProvider>{children}</ThemeProvider>
      </>
    );
  }
};

const Analytic = () => {
  const location: any = useLocation();
  useEffect(() => {
    let type = location.pathname.includes("ccp")
      ? "cancercover"
      : location.pathname.includes("mltc")
      ? "mltc"
      : location.pathname.includes("shieldstarter")
      ? "shieldstarter"
      : location.pathname.includes("evergreen")
      ? "digitalsaver"
      : "sio";
    const GA = GAAviva.getInstance();
    console.log({ type });

    loadGAScript(() => {
      GA.recallFailed();
    }, type);
  }, [location]);
  return <React.Fragment></React.Fragment>;
};

const Configuration = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const location: any = useLocation();
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const isTokenSet = useAvivaSelector((state) => state.loading.isTokenRecieved);
  // const isShieldStarterAgentCode = useAvivaSelector(state=>state.shieldStarterStep4.agentCodeFromUrl)
  const loadConfig = useCallback(async () => {
    try {
      // Retrieve config data
      const response = await getConfig();
      const config = get(response, "data", {});
      window["AVIVA_VARIABLE_CONFIG"] = config;
      console.debug("QnB ➤ loadConfig() ➤ ", { config });
      console.debug("QnB ➤ loadConfig() ➤ showVersion", config["showVersion"]);

      // load error message
      const errorContent: [string, string] = [
        config["genericErrorTitle"],
        config["genericErrorDesc"],
      ];
      dispatch(setErrorContent(errorContent));
      if (location.pathname.includes("mltc")) {
        dispatch(updateBrochureUrl(config["brochureUrlMltc"]));
      } else if (location.pathname.includes("sio")) {
        dispatch(updateBrochureUrl(config["brochureUrlSio"]));
      } else if (location.pathname.includes("dpi")) {
        dispatch(updateBrochureUrl(config["brochureUrlDpi"]));
      } else if (location.pathname.includes("shieldstarter")) {
        dispatch(updateBrochureUrl(config["brochureUrlShieldStarter"]));
      } else if (location.pathname.includes("evergreen")) {
        dispatch(
          updateBrochureUrl(
            config["brochureUrlEvergreen"] ||
              "https://singlife.com/content/dam/public/sg/documents/savings/singlife-digital-saver/brochure.pdf"
          )
        );
      } else if (location.pathname.includes("ccp")) {
        dispatch(
          updateBrochureUrl(
            config["brochureUrlCCP"] ||
              "https://singlife.com/content/dam/public/sg/documents/medical-insurance/singlife-cancer-cover-plus-ii/singlife-cancer-cover-plus-ii-product-brochure.pdf"
          )
        );
      }    
      // Retrieve static banks data
      const responseBanks = await getBanks();
      const banks = get(responseBanks, "data", {});
      dispatch(updateBanks(banks));
      console.debug("QnB ➤ getBanks() ➤ ", { banks });

      // Retrieve campaign code details
      const params = new URLSearchParams(window.location.href.split("?")[1]);
      const campaignCode = params.get("cc");
      console.log("QnB ➤ loadConfig() ➤ check url campaignCode", {
        campaignCode,
        location,
      });
      let pageTitle = Helpers.getPlanName(Helpers.getTypePlan(location));

      // MLTC flow campaign code checks
      if (!!campaignCode && location.pathname.includes("mltc")) {
        const responseCampaign = await postCampaign({ campaign: campaignCode });
        const campaignDetail = get(responseCampaign, "data", {});
        const validCode = !!campaignDetail.description;
        console.debug(`QnB ➤ loadConfig() ➤ postCampaign() ➤ campaignDetail`, {
          campaignDetail,
          validCode,
        });
        pageTitle = validCode
          ? `- ${campaignDetail.description}`
          : Helpers.getPlanName(Helpers.getTypePlan(location));
        if (validCode && campaignDetail?.product === "CARESHIELD") {
          dispatch(setCampaignDetail({ ...campaignDetail, campaignCode }));
        }
      }

      if (config.showVersion) {
        document.title = `Get a quote ${pageTitle} 0.3.8`;
      } else {
        document.title = `Get a quote ${pageTitle}`;
      }
      if (location?.pathname?.includes("shieldstarter") && config.showVersion) {
        document.title = `Get a quote ${pageTitle} 1.7.3`;
      }

      if (
        !isEmpty(config.gtmId) &&
        !location.pathname.includes("shieldstarter")
      ) {
        const tagManagerArgs = {
          gtmId: config.gtmId,
        };
        TagManager.initialize(tagManagerArgs);
      }

      dispatch(setShowAddInfo(config.showAddMyInfo));
      dispatch(setEnableSIO(config.enabledSIO));
      
      const payload = { productCode: "MLTC" };
      const gioEligibilityResponse = await GIOCampaignEligibilityCheck(payload);
      const gioEligibilityCheck = gioEligibilityResponse?.data?.campaignEligible?.includes("GIO");
      const CSTOPUPEligibilityCheck = gioEligibilityResponse?.data?.campaignEligible?.includes("CSTOPUP");

      dispatch(
        setCampaignEligibilityFlags({
          campaignEligibility: gioEligibilityCheck || CSTOPUPEligibilityCheck,
          isGIOEligible: gioEligibilityCheck,
          isCSTopupEligible: CSTOPUPEligibilityCheck,
        }),
      );


    } catch (error) {
      console.error("QnB ➤ loadConfig() ➤ error", { error });
      window["AVIVA_VARIABLE_CONFIG"] = DEFAULT_CONFIG;
    }
  }, [dispatch, location]);

  setCurentPolicyFlowInStore(location.pathname, dispatch);

  // useEffect(() => {
  //   if (
  //     (isShieldStarterAgentCode === "" || isShieldStarterAgentCode !== arc) &&
  //     arc !== null &&
  //     location.pathname.includes("shieldstarter")
  //   ) {
  //     if (dispatch) dispatch(updateAgentCodeFromUrl(arc));
  //   }
  // }, [arc]);

  useEffect(() => {
    if (!isLoaded) {
      loadConfig();
      setIsLoaded(true);
    }
  }, [isLoaded, loadConfig, isTokenSet, setIsLoaded]);

  //Common function to handle the FAST payment call back handler
  //Check if the FAST payment was in progress or not.
  let { isFastPaymenInProgress, productInitiatedFastPayment } =
    useAvivaSelector((state) => state.loading);
  // isFastPaymenInProgress = true
  // productInitiatedFastPayment = PLANS_NAME.SHIELD_STARTER
  useLayoutEffect(() => {
    if (isFastPaymenInProgress) {
      // if the fastpayment in progress and boReference is there in the url param then route the user to accordingly
      let path = getFastPaymentRedirectedUrlAfterRedirect(
        productInitiatedFastPayment as PLANS_NAME
      );
      if (path && !window?.location?.href?.includes(path)) {
        //Redirect the user to the current product fast payment page handler
        path = path.concat(window?.location?.search);
        window?.location?.replace(
          `${window?.location?.pathname || ""}#${path}`
        );
      }
    }
  }, []);
  return <React.Fragment></React.Fragment>;
};

function ReactIdleTime() {
  const history = useHistory();
  const timerRef = useRef<any>(null);
  const sessionTimeOutRef = useRef<any>(null);
  const location = useLocation();
  const isShieldStarter = location.pathname.includes("shieldstarter");
  const isEverGreen = location.pathname.includes("evergreen");
  const isCCP = location.pathname.includes("ccp");
  const [showIdleModal, setShowIdleModal] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const resetShieldStarterStore = useShieldStarterReduxReset();
  const resetCCPStore = useCCPReduxReset();
  const idleTimer = isShieldStarter || isEverGreen ? 300000 : 300000;
  const sessionTimer = isShieldStarter ? 120000 : isEverGreen ? 900000 : 120000;
  const isUseTimer = isShieldStarter || isEverGreen || isCCP;
  //SHield Starter Session and Idle time out checks
  useEffect(() => {
    if (
      location.pathname.includes("/shieldstarter/confirmation") ||
      !isUseTimer
    ) {
      clearTimeout(timerRef.current);
      clearInterval(sessionTimeOutRef.current);
      sessionTimeOutRef.current = null;
      timerRef.current = null;
      window.removeEventListener("mousemove", mouseMove);
      window.removeEventListener("click", mouseMove);
      window.removeEventListener("keypress", keyPress);
      return;
    }
    if (sessionTimeOutRef.current === null && !showSessionModal && isUseTimer) {
      sessionTimeOutRef.current = setInterval(() => {
        let sessionexpiry: number | string | null =
          sessionStorage.getItem("persist:expired");
        sessionexpiry = sessionexpiry ? +sessionexpiry : null;
        const currentTime = new Date().getTime();
        if (sessionexpiry && currentTime >= sessionexpiry) {
          clearInterval(sessionTimeOutRef.current);
          resetShieldStarterStore();
          resetCCPStore();
          setShowSessionModal(true);
          setShowIdleModal(false);
        }
      }, sessionTimer);
    }
    function mouseMove() {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        if (!showIdleModal) {
          setShowIdleModal(true);
        }
      }, idleTimer);
    }
    function keyPress() {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        if (!showIdleModal) {
          setShowIdleModal(true);
        }
      }, idleTimer);
    }
    //Check the idle time out
    if (isUseTimer && !showIdleModal && !showSessionModal) {
      if (timerRef.current === null) {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
          if (!showIdleModal) {
            setShowIdleModal(true);
          }
        }, idleTimer);
      }
      window.addEventListener("mousemove", mouseMove);
      window.addEventListener("click", mouseMove);
      window.addEventListener("keypress", keyPress);
    }
    return () => {
      clearTimeout(timerRef.current);
      clearInterval(sessionTimeOutRef.current);
      sessionTimeOutRef.current = null;
      timerRef.current = null;
      window.removeEventListener("mousemove", mouseMove);
      window.removeEventListener("click", mouseMove);
      window.removeEventListener("keypress", keyPress);
    };
  }, [
    showIdleModal,
    isUseTimer,
    showSessionModal,
    location,
    sessionTimer,
    idleTimer,
  ]);

  if (isEverGreen) {
    return (
      <>
        {showIdleModal && (
          <IdleTimeout
            showIdleModal={showIdleModal}
            setShowIdleModal={setShowIdleModal}
          />
        )}
        {showSessionModal && (
          <SessionTimeout
            showSessionModal={showSessionModal}
            setShowSessionModal={setShowSessionModal}
          />
        )}
      </>
    );
  } else {
    return (
      <>
        {showIdleModal && (
          <ShieldStarterIdleTimeout
            showIdleModal={showIdleModal}
            setShowIdleModal={setShowIdleModal}
            onClickContactUs={() => {
              history.push(
                isCCP
                  ? ROUTE_PATH.CANCER_COVER_CONTACT_US
                  : ROUTE_PATH.SHIELD_STARTER_CONTACT_US
              );
            }}
          />
        )}
        {showSessionModal && (
          <ShieldStarterSessionTimeout
            showSessionModal={showSessionModal}
            setShowSessionModal={setShowSessionModal}
            onGetNewQuote={() => {
              if (isShieldStarter) resetShieldStarterStore();
              if (isCCP) resetCCPStore();
              if (
                window.location.pathname.includes("shieldstarter/get-quote") ||
                window.location.pathname.includes("ccp/quotation-summary")
              ) {
                window.location.reload();
              } else {
                history.replace(
                  isCCP
                    ? ROUTE_PATH.CANCER_COVER_LANDING_PAGE
                    : ROUTE_PATH.SHIELD_STARTER_DEFAULT_HOME_ROUTE
                );
              }
            }}
          />
        )}
      </>
    );
  }
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <ReactIdleTime />
          <ScrollToTop />
          <Loading />
          <Configuration />
          <Analytic />
          <DynamicThemeProvider>
            {/* <Header planName="MrSampleTermPlan" /> */}
            <DynamicHeader />
            <ModalView />
            <div>
              <Switch>
                {/* <Route exact path={'/'}><App /></Route> */}
                <Route
                  exact
                  path={ROUTE_PATH.SHIELD_STARTER_DEFAULT_HOME_ROUTE}
                >
                  <RedirectToGetQuote />
                </Route>
                <Route exact path={"/error"}>
                  <NotFoundPage />
                </Route>
                {[
                  ...sioRoutes,
                  ...dpiRoutes,
                  ...mltcRoutes,
                  ...mltcR3Routes,
                  ...ShieldStarter,
                  ...EverGreen,
                  ...CancerCover,
                ].map((subRoute: any) => {
                  return (
                    <Route
                      key={subRoute.path}
                      path={subRoute.path}
                      render={(props) => (
                        <Suspense fallback={<div>lazy load</div>}>
                          {" "}
                          <subRoute.component {...props} />
                        </Suspense>
                      )}
                    />
                  );
                })}
                <Route
                  path={"/shieldstarter/"}
                  component={() => <Redirect to="error" />}
                />
                <Route component={NotFoundPage} />
              </Switch>
            </div>
            {/* <DynamicRoutes /> */}
            <DynamicFooter />
            <GenericPopup />
            <Toast />
          </DynamicThemeProvider>
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
